import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import Dashlets from 'components/dashlets/Dashlets';

import useHomepage from './Homepage.hook';

const useStyles = makeStyles(() => ({
	pageTitle: {
		marginTop: '25px',
	},
	signpost: {
		height: '300px',
	},
	title: {
		marginTop: '25px',
	},
	justifyText: {
		textAlign: 'justify',
	},
}));

const Homepage: FC = () => {
	const classes = useStyles();

	const { t } = useTranslation('homepage');

	const { data } = useHomepage();

	return (
		<>
			<Dashlets />
			<Grid item xs={1} sm={2} />
			<Grid item xs={10} sm={8}>
				<Typography className={classes.pageTitle} variant="h6" paragraph>
					{t('title')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('p1')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('p2')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('p3')}
				</Typography>
				<Typography className={classes.justifyText} variant="body1" paragraph>
					{t('p4')}
				</Typography>
				<Typography
					className={clsx([classes.justifyText, classes.title])}
					variant="h6"
				>
					{t('published_years')}
				</Typography>
				<Typography
					className={classes.justifyText}
					variant="h6"
					color="textPrimary"
				>
					{data?.publishedYears
						.split(', ')
						.sort((a: string, b: string) => parseInt(a) - parseInt(b))
						.map((item, index) => {
							if (index !== data?.publishedYears.split(', ').length - 1) {
								return `${item}, `;
							}
							return item;
						})}
				</Typography>
			</Grid>
			<Grid item xs={1} sm={2} />
		</>
	);
};

export default Homepage;
